import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { addcompany } from "../redux/blacklist";
import {checkCompanyReg, validYear} from "../utilities/company-reg"

import PlacesAutocomplete from 'react-places-autocomplete';
import {
    geocodeByAddress,
    geocodeByPlaceId,
    getLatLng,
  } from 'react-places-autocomplete';
import axios from "axios";


const CompanyDetails = () => {
    const [blacklistcompany, setBlacklistCompany] = useState('');
    const [companytype, setCompanyType] = useState('');
    const [companyReg, setCompanyReg] = useState('');
    const [companyRegError, setCompanyRegError] = useState('');
    const [validReg, setValidReg] = useState(false)
    const [taxnumber, setTaxNumber] = useState('');
    const [validTax, setValidTax] = useState(false);
    const [taxError, setTaxError] = useState('')

    const [address, setAddress] = useState('');
    const [addressline, setAddressLine] = useState('');
    const [city, setCity] = useState('');
    const [province, setProvince] = useState('');
    const [postal, setPostal] = useState('');

    const [companyphone, setCompanyPhone] = useState(0);
    const [companyemail, setCompanyEmail] = useState('');

    const dispatch = useDispatch();

    const checkTax = (tax) => {
        if (isNaN(tax)) {
            setValidTax(false)
        } else if (tax.split('').length !== 10) {
            setValidTax(false)
        } else {
            setValidTax(true)
        }
    }

    const changeCompanyState = () => {
        dispatch(addcompany({
            blacklistcompany,
            companytype,
            companyReg,
            taxnumber,
            address,
            companyphone,
            companyemail 
            }))
        }
    
    const updateAddress = () => {
        setAddress(`${addressline}, ${city}, ${province}, ${postal}`)
    }

    useEffect(() => {
        if (!validTax) {
            document.getElementById('tax-number').classList.add('border-danger')
            setTaxError('Invalid Tax number')
        } else if (validTax) {
            document.getElementById('tax-number').classList.remove('border-danger')
            setTaxError('')
        }
    }, [validTax])
    
    useEffect(() => {
        if (!validReg) {
            document.getElementById('company-reg').classList.add('border-danger');
            setCompanyRegError('Enter valid company registration number');
        } else if (validReg) {
            document.getElementById('company-reg').classList.remove('border-danger');
            setCompanyRegError('');
        }
    }, [companyReg]);

    useEffect(() => {
        changeCompanyState()
    }, [blacklistcompany, companytype, companyReg, taxnumber, address, companyphone, companyemail])
        
    useEffect(() => {
        updateAddress()
    }, [addressline, city, province, postal])

    const handleChange = address => {
        setAddressLine(address);
      };
    
    const handleSelect = async (address) => {
        setAddressLine(address);
        geocodeByAddress(address)
          .then(results => getLatLng(results[0]))
          .then(async (latLng) => {
            console.log('Success', latLng)
            await axios.get(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${latLng.lat},${latLng.lng}&key=AIzaSyBvRhUM9BphbYPkFBgf5CC1nxOZcHNbXAw`)
            .then(res => {
                const address_components = res.data.results[0].address_components
                address_components.map(element => {
                    if (element.types.includes('postal_code')) {
                        setPostal(element.long_name)
                    } 
                    if (element.types.includes('administrative_area_level_1')) {
                        setProvince(element.long_name)
                        document.getElementById('province').value = element.long_name;
                    }
                    if (element.types.includes('locality')) {
                        setCity(element.long_name)
                    }
                })    
            })
            .catch(err => console.log(err))
            })
          .catch(error => console.error('Error', error));
      };


    return ( 
        <div>
            
            <h2 className="display-6 text-center text-muted mb-3">Company Details</h2>
                    
                    <label for='company' className="form-label">Company Name: <span className="text-danger">*</span></label>
                    <input id="company" name="company" className="form-control" onChange={(e) => {
                        setBlacklistCompany(e.target.value)
                    }} value={blacklistcompany}/>
                    
                    
                    <select name="company-type" class="form-select my-3" onChange={(e) => 
                        {
                            setCompanyType(e.target.value)
                        }
                        }>
                        <option selected >Choose company type <span className="text-danger">*</span></option>
                        <option value="Private Company - (Pty) Ltd">Private Company - (Pty) Ltd</option>
                        <option value="Public Company - Ltd">Public Company - Ltd</option>
                        <option value="Non-Profit Company">Non-Profit Company</option>
                        <option value="Close Corporation-CC">Close Corporation-CC</option>
                    
                    </select>


                    <label for="company-reg" className="form-label" >Registration Number: <span className="text-danger">*</span></label>
                    <input id="company-reg" name="company-reg" className="form-control" onChange={(e) => {
                        setCompanyReg(e.target.value);
                        setValidReg(checkCompanyReg(e.target.value));
                        
                    }} value={companyReg}/>
                    <p className="text-danger text-center">{companyRegError}</p>
                    
                    <label for="tax-number" className="form-label">VAT number:</label>
                    <input id="tax-number" className="form-control" onChange={(e) => {
                        setTaxNumber(e.target.value);
                        checkTax(e.target.value);
                    }}/>

                    <p className="text-danger">{taxError}</p>

                    <label for="address" className="form-label">Address<span className="text-danger">*</span></label>

                    <PlacesAutocomplete
                            value={addressline}
                            onChange={handleChange}
                            onSelect={handleSelect}
                            
                        >
                            {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                            <div >
                                <input
                                {...getInputProps({
                                    placeholder: 'Search Places ...',
                                    className: 'location-search-input form-control',
                                })}
                                />
                                <div className="autocomplete-dropdown-container">
                                {loading && <div>Loading...</div>}
                                {suggestions.map(suggestion => {
                                    
                                    const className = suggestion.active
                                    ? 'suggestion-item--active'
                                    : 'suggestion-item';
                                    // inline style for demonstration purpose
                                const style = suggestion.active
                                ? { backgroundColor: '#fafafa', cursor: 'pointer' }
                                : { backgroundColor: '#ffffff', cursor: 'pointer' };
                                return (
                                <div
                                    {...getSuggestionItemProps(suggestion, {
                                    className,
                                    style,
                                    })}
                                >
                                    <span>{suggestion.description}</span>
                                </div>
                                );
                            })}
                            </div>
                        </div>
                        )}
                    </PlacesAutocomplete>

                    <div className="d-flex flex-wrap">
                        <div className="mx-2">
                            <label htmlFor="city" className="form-label">City: <span className="text-danger">*</span></label>
                            <input value={city} type="text" className="form-control" onChange={(e) => {
                                setCity(e.target.value)
                            }}/>
                        </div>
                        <div className="mx-2">
                            <label htmlFor="province" className="form-label">State/Province: <span className="text-danger">*</span></label>
                            <select className="form-select" id="province" onChange={(e) => {
                                setProvince(e.target.value)
                            }}>
                                <option selected value="Gauteng">Gauteng</option>
                                <option value="KwaZulu-Natal">KwaZulu-Natal</option>
                                <option value="Free State">Free State</option>
                                <option value="Eastern Cape">Eastern Cape</option>
                                <option value="Limpopo">Limpopo</option>
                                <option value="Mpumalanga">Mpumalanga</option>
                                <option value="Northern Cape">Northern Cape</option>
                                <option value="North West">North West</option>
                                <option value="Western Cape">Western Cape</option>
                            </select>
                        </div>
                        <div className="mx-2">
                            <label htmlFor="postcode" className="form-label">Zip/Postal Code: <span className="text-danger">*</span></label>
                            <input className="form-control" onChange={(e) => {
                                setPostal(e.target.value)
                            }} value={postal}  />
                        </div>
                    </div>

                    <label htmlFor="phone" className="form-label">Company contact number: <span className="text-danger">*</span> </label>
                    <input className="form-control" onChange={(e) => {
                        setCompanyPhone(e.target.value)
                        changeCompanyState()
                    }}/>

                    <label htmlFor="email">Company email: <span className="text-danger">*</span></label>
                    <input type="email" className="form-control" onChange={(e) => {
                        setCompanyEmail(e.target.value)
                        changeCompanyState()

                    }}/>
        </div>
        
     );
}
 
export default CompanyDetails;